var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTextField',_vm._g(_vm._b({attrs:{"rules":[_vm.ruleNotEmptyString],"prepend-inner-icon":_vm.mdiCart,"label":"Numer zamówienia UMAMI","outlined":""}},'VTextField',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }